import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { MyBuildingsResourcePackage } from "../resources/MyBuildingsResourcePackage";

export class LockedContainer extends Container {
    private static readonly LOCKED_TOP_TEXT = "OPEN AT";
    private static readonly LOCKED_BOTTOM_TEXT = "RANK";

    private readonly lockedTopSprite: Sprite;
    private readonly lockedTopText: Text;
    private readonly lockedBottomSprite: Sprite;
    private readonly lockedBottomText: Text;

    public constructor(myBuildingsResources: MyBuildingsResourcePackage, openAtRank: number) {
        super();

        this.lockedTopSprite = new Sprite(myBuildingsResources.assets_views_mybuildings_ui_locked1_png);
        this.lockedTopText = new Text(LockedContainer.LOCKED_TOP_TEXT, new LockedTextStyle());
        this.lockedTopText.angle = -35;
        this.lockedTopText.position.set(54, 42);
        this.lockedTopSprite.addChild(this.lockedTopText);
        this.lockedTopSprite.position.set(-100, 0);
        this.addChild(this.lockedTopSprite);

        this.lockedBottomSprite = new Sprite(myBuildingsResources.assets_views_mybuildings_ui_locked2_png);
        this.lockedBottomText = new Text(`${LockedContainer.LOCKED_BOTTOM_TEXT} ${openAtRank}`, new LockedTextStyle());
        this.lockedBottomText.angle = -35;
        this.lockedBottomText.position.set(14, 47);
        this.lockedBottomSprite.addChild(this.lockedBottomText);
        this.lockedBottomSprite.position.set(-9, -41);
        this.addChild(this.lockedBottomSprite);
    }
}

class LockedTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fill: "#FFD500",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 24
        });
    }
}
